<template>
  <div class="mobile-header">
    <div
      v-if="activeSubMenu"
      class="mobile-header__back"
      @click="activeSubMenu = null"
    >
      <img src="@/assets/icons/i_arrow-red.svg" alt="arrow" />
    </div>
    <div class="mobile-header__close" @click="closeMenu">
      <img src="@/assets/icons/i_close.svg" alt="close" />
    </div>
    <div v-if="!activeSubMenu" class="mobile-header__nav">
      <ul class="mobile-header__nav-links">
        <li
          v-for="(item, index) in menu"
          :key="index"
          :class="{ 'not-access': checkAccess(item.access) }"
        >
          <a v-if="item.tag" :href="item.link" target="_blank">
            {{ item.title }}
          </a>
          <nuxt-link v-else :to="item.link">
            {{ item.title }}
          </nuxt-link>
          <img
            v-if="item.submenu"
            src="../../assets/icons/i_arrow-right.svg"
            alt="arrow"
            @click="openSubMenu(item)"
          />
        </li>
      </ul>
      <ul class="mobile-header__nav-profile">
        <li v-if="isAuthorize">
          <div class="mobile-header__logout">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path
                fill="#003865"
                d="M16.572,11.426a8.431,8.431,0,0,0-2.15-1.346.7.7,0,1,0-.571,1.285,7.031,7.031,0,0,1,1.793,1.117,2.8,2.8,0,0,1,.95,2.107v1.3a.7.7,0,0,1-.7.7H2.109a.7.7,0,0,1-.7-.7v-1.3a2.8,2.8,0,0,1,.95-2.107c.71-.624,2.78-2.076,6.644-2.076a5.209,5.209,0,1,0-3.169-1.08,9.775,9.775,0,0,0-4.4,2.1A4.21,4.21,0,0,0,0,14.59v1.3A2.112,2.112,0,0,0,2.109,18H15.891A2.112,2.112,0,0,0,18,15.891v-1.3A4.21,4.21,0,0,0,16.572,11.426ZM5.2,5.2A3.8,3.8,0,1,1,9,9,3.8,3.8,0,0,1,5.2,5.2Z"
              />
            </svg>
            <p>MYPC</p>
          </div>
          <img
            src="@/assets/icons/i_arrow-right.svg"
            alt="arrow"
            @click="openSubMenu(profileMenu)"
          />
        </li>
        <li v-if="isAuthorize">
          <button class="mobile-header__logout" @click="handleLogout">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16.83"
              height="19"
              viewBox="0 0 16.83 19"
            >
              <g
                id="Icon:_Logout"
                data-name="Icon: Logout"
                transform="translate(-35.861 0.501)"
              >
                <path
                  fill="#003865"
                  d="M47.354,66.878a.63.63,0,0,0-.816.355h0a.633.633,0,0,0,.356.817,7.155,7.155,0,1,1-5.236,0,.63.63,0,0,0,.021-1.164.624.624,0,0,0-.481-.008,8.415,8.415,0,1,0,6.157,0Z"
                  transform="translate(0 -64.626)"
                />
                <path
                  fill="#003865"
                  d="M229.225,11.583a.7.7,0,0,0,.7-.7V.2a.7.7,0,1,0-1.406,0V10.88A.7.7,0,0,0,229.225,11.583Z"
                  transform="translate(-184.909)"
                />
              </g>
            </svg>
            <p>LOGOUT</p>
          </button>
        </li>
        <li v-else>
          <nuxt-link to="/login" class="mobile-header__logout">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path
                fill="#003865"
                d="M16.572,11.426a8.431,8.431,0,0,0-2.15-1.346.7.7,0,1,0-.571,1.285,7.031,7.031,0,0,1,1.793,1.117,2.8,2.8,0,0,1,.95,2.107v1.3a.7.7,0,0,1-.7.7H2.109a.7.7,0,0,1-.7-.7v-1.3a2.8,2.8,0,0,1,.95-2.107c.71-.624,2.78-2.076,6.644-2.076a5.209,5.209,0,1,0-3.169-1.08,9.775,9.775,0,0,0-4.4,2.1A4.21,4.21,0,0,0,0,14.59v1.3A2.112,2.112,0,0,0,2.109,18H15.891A2.112,2.112,0,0,0,18,15.891v-1.3A4.21,4.21,0,0,0,16.572,11.426ZM5.2,5.2A3.8,3.8,0,1,1,9,9,3.8,3.8,0,0,1,5.2,5.2Z"
              />
            </svg>
            <p>LOGIN</p>
          </nuxt-link>
        </li>
      </ul>
    </div>
    <div v-else class="mobile-header__subnav">
      <p class="mobile-header__subnav-title">
        {{ activeSubMenu.title }}
      </p>
      <ul>
        <li
          v-for="(item, index) in activeSubMenu.submenu"
          :key="index"
          :class="{
            'not-subscribe':
              (notSubscribeEurope && item.link === '/benchmarking/europe') ||
              (notSubscribeAmerica &&
                item.link === '/benchmarking/north-america'),
          }"
        >
          <nuxt-link :to="item.link">
            {{ item.title }}
          </nuxt-link>
          <Tooltip v-if="notSubscribeEurope || notSubscribeAmerica" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import logout from "../../utils/logout";
import { menu, profileMenu, reportsMenu } from "@/config";

export default {
  name: "MobileHeader",
  components: {
    Tooltip: () => import("../elements/Tooltip"),
  },
  data() {
    return {
      menu,
      profileMenu,
      reportsMenu,
      activeSubMenu: null,
      notSubscribeEurope: false,
      notSubscribeAmerica: false,
    };
  },
  computed: {
    ...mapState("Auth", ["isAuthorize"]),
    ...mapState("Profile", ["userAccess"]),
  },
  watch: {
    $route(to, from) {
      this.closeMenu();
    },
  },
  mounted() {
    if (!this.userAccess.find((el) => el === "4124")) {
      this.notSubscribeEurope = true;
    }
    if (!this.userAccess.find((el) => el === "4123")) {
      this.notSubscribeAmerica = true;
    }
  },
  methods: {
    openSubMenu(item) {
      this.activeSubMenu = item;
    },
    closeMenu() {
      this.$emit("close");
    },
    handleLogout() {
      this.$router.push("/login");
      logout(this);
      this.closeMenu();
    },
    checkAccess(access) {
      let isNotAccess = false;
      if (access) {
        isNotAccess = !this.userAccess.find((el) => el === access);
      }
      return isNotAccess;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.mobile-header {
  position: fixed;
  z-index: 20;
  width: 100%;
  min-height: 100vh;
  background: $white;
  top: 0;
  left: 0;
  padding: 8.2rem 2.5rem 2.5rem;
  &__nav {
    &-links {
      border-bottom: 1px solid #b1b3b3;
      margin-bottom: 2.2rem;
      li {
        margin-bottom: 2.2rem;
        display: flex;
        justify-content: space-between;
        position: relative;
        &.not-access {
          &:after {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            content: "";
            background: rgba(255, 255, 255, 0.7);
            cursor: not-allowed;
          }
        }
      }
      a {
        font-size: 1.9rem;
        text-transform: uppercase;
        color: $text;
        text-decoration: none;
        font-weight: 700;
      }
    }
    &-profile {
      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 2.2rem;
      }
    }
  }
  &__logout {
    border: 0;
    box-shadow: none;
    background: none;
    text-decoration: none;
    display: flex;
    align-items: center;
    color: inherit;
    p {
      font-size: 1.6rem;
      font-weight: 600;
      margin-left: 1.8rem;
      text-transform: uppercase;
    }
  }
  &__subnav {
    &-title {
      font-size: 1.9rem;
      text-transform: uppercase;
      color: $text;
      border-bottom: 3px solid $text;
      font-weight: 700;
      margin-bottom: 2rem;
    }
    li {
      position: relative;
      &.not-subscribe {
        &:after {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          content: "";
          background: rgba(255, 255, 255, 0.7);
          cursor: not-allowed;
        }

        .tooltip {
          max-width: 100%;
          width: 100%;
        }
      }
    }
    a {
      font-size: 1.8rem;
      line-height: 3.3rem;
      text-decoration: none;
      color: $text;
    }
  }
  &__back,
  &__close {
    position: absolute;
    top: 3rem;
  }
  &__close {
    right: 1.8rem;
  }
}
</style>
